var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"backTopButton",staticClass:"back-top-button",on:{"click":_vm.scrollTop}})
}
var staticRenderFns = []

export { render, staticRenderFns }